import script from "./Tool.vue?vue&type=script&setup=true&lang=js"
export * from "./Tool.vue?vue&type=script&setup=true&lang=js"

import "./Tool.vue?vue&type=style&index=0&id=aae5bed0&lang=scss"

const __exports__ = script;

export default __exports__